var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69498 2.0122C8.87139 1.86572 9.12862 1.86572 9.30502 2.0122C11.0499 3.46107 13.2583 4.37102 15.675 4.4867C15.8922 4.4971 16.0777 4.65399 16.1062 4.86958C16.1681 5.33745 16.2 5.81477 16.2 6.29955C16.2 10.9457 13.2661 14.9067 9.1499 16.4308C9.05339 16.4665 8.94692 16.4665 8.85041 16.4308C4.73404 14.9068 1.8 10.9457 1.8 6.29944C1.8 5.8147 1.83194 5.33742 1.89382 4.86959C1.92234 4.65399 2.10782 4.4971 2.32504 4.4867C4.74165 4.37102 6.95008 3.46108 8.69498 2.0122ZM12.4709 7.37131C12.6902 7.06982 12.6235 6.64766 12.322 6.4284C12.0205 6.20913 11.5984 6.27579 11.3791 6.57728L8.24373 10.8884L6.5523 9.19699C6.2887 8.93339 5.86131 8.93339 5.59771 9.19699C5.3341 9.4606 5.3341 9.88798 5.59771 10.1516L7.84771 12.4016C7.9873 12.5412 8.181 12.6127 8.3778 12.5972C8.57461 12.5818 8.75479 12.481 8.8709 12.3213L12.4709 7.37131Z",
    fill: "#F6F2FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.b54b25d024a4441850bce8a56b2d47ab.svg";
export { ForwardRef as ReactComponent };